import {BottomSheet} from 'react-spring-bottom-sheet';
import Button from '../../../../components/button';

export type CashbackSheet = 'cash-back' | 'active-credit' | null;

interface IDefaultCashBackSheetProps {
  open: boolean;
  onClose: () => void;
}

const DefaultCashBackSheet = ({open, onClose}: IDefaultCashBackSheetProps) => {
  return (
    <BottomSheet
      open={open}
      onDismiss={onClose}
      blocking
      className="custom-bottom-sheet"
    >
      <div className="relative flex flex-col w-full p-6">
        <button
          type="button"
          aria-label="بستن"
          className="absolute outline-none left-6 top-6 ring-0 focus:outline-none focus:ring-0 focus-visible:outline-none"
          onClick={onClose}
        >
          <i className="text-2xl text-gray-500 icon-nameClose-remove" />
        </button>

        <div className="flex flex-col items-center">
          <i className="mb-1 text-3xl icon-namereport text-farm-shop-600" />

          <h2 className="mb-0 text-lg font-medium text-gray-950">
            اعتبار بازگشتی
          </h2>
        </div>

        <span className="mt-3 text-sm font-medium text-zinc-600">
          تا کنون بازگشت وجه نداشتید!
        </span>

        <div className="mt-2 text-sm font-normal text-zinc-600">
          با خرید از فروشگاه مزرعه تا 10 درصد از مبلغ خریدتان به کیف پول شما
          واریز میشود.
        </div>

        <div className="flex justify-end mt-3">
          <Button onClick={onClose}>متوجه شدم</Button>
        </div>
      </div>
    </BottomSheet>
  );
};

export default DefaultCashBackSheet;
